export const login = {
  header: 'Incorrect email or password',
  description:
    'Make sure this is the same email you used when you placed your order or created your account.'
};
